import TSelect from './select.vue'
import TOption from './option.vue'
import TOptionGroup from './option-group.vue'
TSelect.Option = TOption
TSelect.OptionGroup = TOptionGroup
export default TSelect



// WEBPACK FOOTER //
// ./src/components/select/index.js